// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footer-content":"Footer_footer-content__SH5MF","footer-dev":"Footer_footer-dev__1Itlj","footer-link":"Footer_footer-link__2mZ5B"};